import {
  Button,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from '@mui/material';
import { Box } from '@mui/system';
import { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import Toaster from 'src/Toaster/Toaster';
import { Helmet } from 'react-helmet-async';
import { LoadingButton } from '@mui/lab';
import CommonMultipleSelectMembers from 'src/common/CommonMultipleSelectMembers';
import SelectGroupMemberList from '../group/SelectGroupMemberList';
import UpdateDataApi from 'src/common/FetchData/UpdateDataApi';
import GetDataApi from 'src/common/FetchData/GetDataApi';

type IGroupSingleType = {
  id: number;
  text: string;
  type: string;
  status: number;
  created_by: number;
  created_at: string;
  update_at: string;
  members: {
    member_id: number;
    company_name: string;
    group_name: string;
  }[];
  groups: {
    id: number;
    name: string;
  }[];
};
function EditSMS({
  handleClose,
  id,
}: {
  id: string | number;
  handleClose?: () => void;
}) {
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm();
  const {
    getData,
    response,
    success: getSuc,
  } = GetDataApi<IGroupSingleType>(`/api/admin/member-sms/${id}`, true);
  const { updateData, loading, success } = UpdateDataApi(
    `/api/admin/member-sms/${id}`
  );
  const [meetingType, setMeetingType] = useState('');
  const Toast = Toaster();

  const [allMember, setAllMember] = useState<number[]>([]);
  const [newGroupId, setNewGroupId] = useState<number[]>([]);
  const [removeGroupId, setRemoveGroupId] = useState<number[]>([]);
  const [newAddMemberId, setNewMemberId] = useState<number[]>([]);
  const [removeMemberId, setremoveMemberId] = useState<number[]>([]);

  const onSubmit = async (inputs: any) => {
    if (!meetingType) {
      Toast.fire({
        icon: 'error',
        title: `Please select meeting type`,
      });
      return;
    }

    const body: {
      text?: string;
      type?: string;
      remove_groups?: number[];
      add_groups?: number[];
      add_member?: number[];
      remove_member?: number[];
    } = {};
    if (inputs?.text) {
      body.text = inputs.text;
    }
    if (meetingType && (newGroupId?.length || removeGroupId?.length)) {
      body.type = meetingType;
      if (newGroupId?.length) {
        body.add_groups = newGroupId;
      }
      if (removeGroupId?.length) {
        body.remove_groups = removeGroupId;
      }
    }
    if (meetingType && (newGroupId?.length || removeGroupId?.length)) {
      body.type = meetingType;
      if (newGroupId?.length) {
        body.add_groups = newGroupId;
      }
      if (removeGroupId?.length) {
        body.remove_groups = removeGroupId;
      }
    }

    if (meetingType && (newAddMemberId?.length || removeMemberId?.length)) {
      if (newAddMemberId?.length) {
        body.add_member = newAddMemberId;
      }
      if (removeMemberId?.length) {
        body.remove_member = removeMemberId;
      }
    }
    if (!Object?.keys(body)?.length) {
      Toast.fire({
        icon: 'error',
        title: `Please change the field`,
      });
      return;
    }
    await updateData(body);
  };

  useEffect(() => {
    if (id) {
      getData();
    }
  }, [id]);

  useEffect(() => {
    if (getSuc) {
      setMeetingType(response?.type);
    }
  }, [getSuc]);
  useEffect(() => {
    if (success) {
      handleClose();
    }
  }, [success]);

  return (
    <>
      <Helmet>
        <title>Atab - Create sms</title>
      </Helmet>

      <Box component='form' onSubmit={handleSubmit(onSubmit)} sx={{ px: 1 }}>
        <Grid container spacing={2}>
          <Grid xs={12} md={12} lg={12} item>
            <TextField
              fullWidth
              label='Write SMS'
              multiline
              required
              rows={4}
              id='outlined-required'
              type='text'
              defaultValue={response?.text}
              aria-invalid={errors.member_meeting_detail ? 'true' : 'false'}
              helperText={
                errors.member_meeting_detail?.type === 'required' &&
                'Meeting details is required'
              }
              InputLabelProps={{
                shrink: true, // Force the label to shrink
              }}
              {...register('text')}
            />
          </Grid>

          <Grid xs={12} md={12} lg={12} item>
            <FormControl fullWidth>
              <InputLabel id='demo-simple-select-label'>
                Meeting type
              </InputLabel>
              <Select
                defaultValue={response?.type}
                fullWidth
                labelId='demo-simple-select-label'
                id='demo-simple-select'
                value={meetingType}
                label=' Meeting type'
                onChange={(e) => setMeetingType(e.target.value)}
                required
              >
                <MenuItem value={'all'}>All</MenuItem>
                <MenuItem value={'specific'}>Specific</MenuItem>
                <MenuItem value={'group'}>Group</MenuItem>
              </Select>
            </FormControl>
          </Grid>

          {meetingType === 'specific' && (
            <Grid xs={12} md={12} lg={12} item>
              <CommonMultipleSelectMembers
                onChange={(e) => {
                  setAllMember(e);
                }}
                label='Select Members'
                size='medium'
                defaultData={
                  response &&
                  response?.members?.map((item) => ({
                    user_member_id: item.member_id,
                    user_member_company_name: item.company_name,
                  }))
                }
                onAddValue={(e) => setNewMemberId(e)}
                onRemoveValue={(e) => setRemoveGroupId(e)}
              />
            </Grid>
          )}
          {meetingType === 'group' && response.groups.length && (
            <Grid xs={12} md={12} lg={12} item>
              <SelectGroupMemberList
                onChange={(e) => { }}
                onAddValue={(e) => setNewGroupId(e)}
                onRemoveValue={(e) => setRemoveGroupId(e)}
                label='Select Group List'
                size='medium'
                defaultData={response?.groups || []}
              />
            </Grid>
          )}

          <Grid xs={12} md={12} lg={12} item>
            {!loading ? (
              <Button
                type='submit'
                fullWidth
                variant='contained'
                disableElevation
              >
                Create
              </Button>
            ) : (
              <LoadingButton
                fullWidth
                loading
                loadingIndicator='Creating...'
                variant='contained'
                disabled
              >
                <span>Creating...</span>
              </LoadingButton>
            )}
          </Grid>
        </Grid>
      </Box>
    </>
  );
}

export default EditSMS;
